<template>

    <div v-if="isModalVisible" class="modal-overlay">
      <div class="modal">
        <h3 class="modal-title">Ошибка регистрации</h3>
        <p class="modal-message">{{ errorMessage }}</p>
        <button class="modal-button" @click="isModalVisible = false">Закрыть</button>
      </div>
    </div>

  <div class="login-container">
    <div class="login-header">
      <img class="login-logo" />
    </div>

    <div class="register-wrapper">
      <div class="register_form" v-if="!isRegistered">
        <PhoneForm @register="handleRegistration" />
      </div>

      <div class="success-message" v-else>
        <h3 class="success-title">Регистрация успешна!</h3>
        <p class="success-text">
          Мы отправили письмо с подтверждением на ваш email.
          <br />Откройте почту и следуйте инструкциям, чтобы активировать аккаунт.
        </p>
      </div>
    </div>

    <Footer />

    <div v-if="isLoading" class="overlay">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PhoneForm from "../components/login/PhoneForm.vue";
import RegistrationService from "../api/RegistrationService.js";
import Footer from "../components/Footer.vue";

const isLoading = ref(false);
const isModalVisible = ref(false);
const errorMessage = ref("");
const isRegistered = ref(false);

const handleRegistration = async ({ email, password }) => {
try {
  isLoading.value = true;
  localStorage.setItem("emailForSignIn", email);
  localStorage.setItem("user_password", password);

  const response = await RegistrationService.registerUser(email, password);

  if (response.success) {
    isRegistered.value = true;
  } else {
    errorMessage.value = response.error;
    isModalVisible.value = true;
  }
} catch (error) {
  // 🔥 Проверим: ошибка от сервера или вообще сеть умерла
  if (error.response) {
    errorMessage.value = error.response.data?.error || "Ошибка регистрации (сервер)";
  } else {
    errorMessage.value = "Нет подключения к серверу. Попробуйте позже.";
  }
  isModalVisible.value = true;
} finally {
  isLoading.value = false;
}
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: var(--bg);
  overflow-x: hidden;
  position: relative;
}

.login-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 750px;
  background-size: cover;
  background-position: center;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 20px;
}

[data-theme="dark"] .login-header {
  background-image: url('../assets/login_header_dark.webp');
}

[data-theme="light"] .login-header {
  background-image: url('../assets/login_header_light.webp');
}

.login-logo {
  content: url('../assets/login_logo_dark.png');
}

[data-theme="light"] .login-logo {
  content: url('../assets/login_logo_light.png');
}

.login-logo {
  width: 180px;
  height: auto;
  max-width: 100%;
  transform: translateY(-20px);
  content: url("../assets/login_logo_dark.png");
}

[data-theme="light"] .login-logo {
  content: url("../assets/login_logo_light.png");
}

.register-wrapper {
  position: relative;
  z-index: 2;
  margin-top: 140px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 20px;
}

/* Footer как в Login.vue */
footer {
  width: 100%;
  z-index: 5;
}

.modal-overlay {
position: fixed;
inset: 0; /* аналог top:0, right:0, bottom:0, left:0 */
background-color: rgba(0, 0, 0, 0.6);
display: flex;
align-items: center;
justify-content: center;
z-index: 1000; /* убедимся, что выше остальных элементов */
}

.modal {
background: #fff;
color: #000;
padding: 24px 32px;
border-radius: 12px;
max-width: 320px;
width: 100%;
box-shadow: 0 4px 12px rgba(0,0,0,0.25);
text-align: center;
font-family: "Eastman-Regular", sans-serif;
}

.modal-title {
font-size: 18px;
font-weight: bold;
margin-bottom: 10px;
}

.modal-message {
font-size: 14px;
margin-bottom: 20px;
line-height: 1.4;
}

.modal-button {
background-color: #2173E5;
color: white;
border: none;
padding: 10px 20px;
border-radius: 25px;
font-family: "Eastman-Bold", sans-serif;
cursor: pointer;
transition: opacity 0.2s ease;
}

.modal-button:hover {
opacity: 0.9;
}
/* Убираем только горизонтальный скролл */
html, body {
  overflow-x: hidden;
}
</style>